import type { ReactNode } from 'react';
import type { ViewSignatureSlot } from '@/lib/contract-signing';
import './contract-document.css';

export function ContractSignatureInk({
  image,
  name,
  role,
  signedAt,
  waitNote,
  capture,
}: {
  image?: string | null;
  name?: string | null;
  role: string;
  signedAt?: string | null;
  waitNote?: string | null;
  capture?: ReactNode;
}) {
  return (
    <>
      {image ? (
        <img
          src={image}
          alt={`Signature of ${name || role}`}
          className="cd-sig-image"
          referrerPolicy="no-referrer"
        />
      ) : capture ? (
        capture
      ) : waitNote ? (
        <p className="cd-sig-wait">{waitNote}</p>
      ) : (
        <div className="cd-sig-blank">Signature</div>
      )}
      {(signedAt || image) && (
        <p className="cd-muted">
          Signed{signedAt && signedAt !== 'Signed' ? ` ${signedAt}` : ''}
        </p>
      )}
    </>
  );
}

/** Compact confirmation strip — same pads as View, no editor chrome. */
export function ContractSignaturePreview({
  slots,
  layout = 'grid',
  testId = 'contract-signature-preview',
}: {
  slots: ViewSignatureSlot[];
  /** `stack` is for the narrow Contracts inspector; `grid` is the document strip. */
  layout?: 'grid' | 'stack';
  testId?: string;
}) {
  const stacked = layout === 'stack';
  return (
    <div
      className={
        stacked
          ? 'cd-sig-preview cd-sig-preview--stack'
          : 'cd-sig-grid cd-sig-preview'
      }
      data-testid={testId}
      data-layout={layout}
    >
      {slots.map((slot) => (
        <div key={slot.key} className="cd-sig-panel" data-testid={`${testId}-${slot.key}`}>
          <div className="cd-sig-panel-h">
            <span className="cd-sig-panel-role">{slot.role}</span>
            <span className="cd-sig-panel-name">{slot.name || 'Name at signing'}</span>
          </div>
          <div className="cd-sig-panel-b">
            <div className="cd-sig-preview-ink">
              <ContractSignatureInk
                image={slot.signatureImage}
                name={slot.name}
                role={slot.role}
                signedAt={slot.signedAt}
                waitNote={slot.waitNote}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
